import type { LocationQuery } from 'vue-router'

export const getTemplateFromRouteQuery = (query: LocationQuery) => {
  const value = query.template?.toString() as 'map' | 'list'
  if (value === 'map' || value === 'list') return value
  return 'split'
}
